import { styled, TableBody as MuiTableBody } from "@mui/material";

const PREFIX = "ActionTableBodyStyle";
export const classes = {
  tableCell: `${PREFIX}-tableCell`
};

export const TableBody = styled(MuiTableBody)(() => ({
  [`& .${classes.tableCell}`]: {
    border: "none"
  }
}));
